import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentSipRoutingModule } from './payment-sip-routing.module';
import { PaymentSipComponent } from './payment-sip.component';
import { PaymentSipOptionsModule } from '../payment-sip-options/payment-sip-options.module';
import { PaymentSipFormModule } from '../payment-sip-form/payment-sip-form.module';
import { GCaptchaModule } from '../g-captcha/g-captcha.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';

@NgModule({
  declarations: [PaymentSipComponent],
  exports: [PaymentSipComponent],
  imports: [
    CommonModule,
    PaymentSipRoutingModule,
    PaymentSipOptionsModule,
    PaymentSipFormModule,
    GCaptchaModule,
    ModuleLoaderModule
  ]
})
export class PaymentSipModule { }
